// extracted by mini-css-extract-plugin
module.exports = {"dropdownCursor":"workspace-create-step_dropdownCursor_NSW"};